import { render, staticRenderFns } from "./OptimizationPage.vue?vue&type=template&id=6a875abd"
import script from "./OptimizationPage.vue?vue&type=script&lang=js"
export * from "./OptimizationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports